

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const BULKUPLOADKRAKPIS= createAsyncThunk(
  "bulkUploadKraKpis/bulkUploadKraKpis",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const bulkUploadKraKpisSlice = createSlice({
  name: "bulkUploadKraKpisSlice",
  initialState: {
    bulkUploadKraKpis: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfbulkUploadKraKpis: (state) => {
        state.bulkUploadKraKpis.loading = false
        state.bulkUploadKraKpis.error = false
        state.bulkUploadKraKpis.data = []
        state.bulkUploadKraKpis.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(BULKUPLOADKRAKPIS.fulfilled, (state, action) => {
      state.bulkUploadKraKpis = {
        ...state.bulkUploadKraKpis,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(BULKUPLOADKRAKPIS.pending, (state, action) => {
      state.bulkUploadKraKpis = {
        ...state.bulkUploadKraKpis,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(BULKUPLOADKRAKPIS.rejected, (state, action) => {
      state.bulkUploadKraKpis = {
        ...state.bulkUploadKraKpis,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const bulkUploadKraKpisAction = {
    BULKUPLOADKRAKPIS,
};

export { bulkUploadKraKpisAction };
export default bulkUploadKraKpisSlice.reducer;
export const {setInitialStateOfbulkUploadKraKpis} = bulkUploadKraKpisSlice.actions
